import { render } from "./manager_plans.vue?vue&type=template&id=4bd7e9bc"
import script from "./manager_plans.vue?vue&type=script&lang=js"
export * from "./manager_plans.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__